import LedgerSection from "./LedgerSection";
import { getB2CLedger } from "../../services/salesDashboard";

const B2CLedger = () => (
  <LedgerSection title="B2C Ledger" typeLabel="B2C" fetchFn={getB2CLedger} paginated />
);

export default B2CLedger;
